<template>
    <op-address v-model="localValue.address" :showAsterisks="showAsterisks" label="Indirizzo di fatturazione"></op-address>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as CONST from '@/const';
import * as VM from '@/viewmodel';
import { mixins, Options, Vue } from 'vue-class-component';
import store from '@/store';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class billingAddress extends mixins(WithModel) {

    declare localValue: OM.BillingInfo;
    
    @Prop({
        default: false
    }) showAsterisks: boolean;

}

</script>
